import Arrow from './icons/arrow-svg';
import Bag from './icons/bag-svg';
import Bell from './icons/bell-svg';
import CircleEmpty from './icons/circle-0-svg';
import Circle31 from './icons/circle-3-1-svg';
import Circle32 from './icons/circle-3-2-svg';
import Circle61 from './icons/circle-6-1-svg';
import Circle62 from './icons/circle-6-2-svg';
import Circle63 from './icons/circle-6-3-svg';
import Circle64 from './icons/circle-6-4-svg';
import Circle65 from './icons/circle-6-5-svg';
import Circle91 from './icons/circle-9-1-svg';
import Circle92 from './icons/circle-9-2-svg';
import Circle93 from './icons/circle-9-3-svg';
import Circle94 from './icons/circle-9-4-svg';
import Circle95 from './icons/circle-9-5-svg';
import Circle96 from './icons/circle-9-6-svg';
import Circle97 from './icons/circle-9-7-svg';
import Circle98 from './icons/circle-9-8-svg';
import Circle121 from './icons/circle-12-1-svg';
import Circle122 from './icons/circle-12-2-svg';
import Circle123 from './icons/circle-12-3-svg';
import Circle124 from './icons/circle-12-4-svg';
import Circle125 from './icons/circle-12-5-svg';
import Circle126 from './icons/circle-12-6-svg';
import Circle127 from './icons/circle-12-7-svg';
import Circle128 from './icons/circle-12-8-svg';
import Circle129 from './icons/circle-12-9-svg';
import Circle1210 from './icons/circle-12-10-svg';
import Circle1211 from './icons/circle-12-11-svg';
import CircleFull from './icons/circle-full-svg';
import Currency from './icons/currency-svg';
import Customer from './icons/customer-svg';
import DataEmptyState from './icons/data-empty-state-svg';
import Dispatch from './icons/dispatch-svg';
import ErrorCross from './icons/error-cross-svg';
import ExclamationPoint from './icons/exclamationPoint-svg';
import Alert from './icons/ic24-alert-svg';
import Chart from './icons/ic24-chart-bar-svg';
import ListBullet from './icons/ic24-list-bullet-svg';
import Phone from './icons/ic24-phone-in-talk-svg';
import SettingsMenu from './icons/ic24-settings-svg';
import Cart from './icons/ic24-shopping-cart-svg';
import Sync from './icons/ic24-sync-svg';
import Info from './icons/info-svg';
import LogoAR from './icons/logo-ar-svg';
import LogoEN from './icons/logo-en-svg';
import Logout from './icons/logout-svg';
import MenuIcon from './icons/menu-icon-svg';
import Merchant from './icons/merchant-svg';
import MessageEmptyState from './icons/message-empty-state-svg';
import NotificationRead from './icons/notification-read-svg';
import NotificationUnread from './icons/notification-unread-svg';
import Outstanding from './icons/outstanding-svg';
import Padlock from './icons/padlock-svg';
import PartnerSVG from './icons/partner-svg';
import Renewals from './icons/renewal-svg';
import Settings from './icons/settings-svg';
import Smile from './icons/smile-svg';
import Store from './icons/store-svg';
import SuccessTick from './icons/success-tick-svg';

const circles: any = {
  id0: CircleEmpty,
  id31: Circle31,
  id32: Circle32,
  id61: Circle61,
  id62: Circle62,
  id63: Circle63,
  id64: Circle64,
  id65: Circle65,
  id91: Circle91,
  id92: Circle92,
  id93: Circle93,
  id94: Circle94,
  id95: Circle95,
  id96: Circle96,
  id97: Circle97,
  id98: Circle98,
  id121: Circle121,
  id122: Circle122,
  id123: Circle123,
  id124: Circle124,
  id125: Circle125,
  id126: Circle126,
  id127: Circle127,
  id128: Circle128,
  id129: Circle129,
  id1210: Circle1210,
  id1211: Circle1211,
};
const Circle = (id: string | null) =>
  id === null ? CircleFull : circles[`id${id}`];

export {
  Circle,
  LogoAR,
  LogoEN,
  Bell,
  Logout,
  NotificationRead,
  NotificationUnread,
  DataEmptyState,
  MessageEmptyState,
  Settings,
  Currency,
  Customer,
  Bag,
  Alert,
  Chart,
  ListBullet,
  Phone,
  SettingsMenu,
  Cart,
  Sync,
  MenuIcon,
  Dispatch,
  Store,
  Merchant,
  Arrow,
  Padlock,
  SuccessTick,
  ErrorCross,
  Renewals,
  ExclamationPoint,
  Info,
  Outstanding,
  Smile,
  PartnerSVG,
};
